import { useState } from 'react'

import { Box, Button, NoticeBox } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import TrialEmployeeDeleteModal from 'modules/employees/components/EmployeesList/components/_TrialEmployees/_TrialDeleteModal'
import { useGetTrialEmployees } from 'modules/employees/hooks/useGetTrialEmployees'

type Props = {
  onSuccess: () => void
}

const TrialNoticeBox = ({ onSuccess }: Props) => {
  const { loading, trialEmployees } = useGetTrialEmployees()
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleClick = async () => {
    setIsModalOpen(true)
  }

  if (loading || trialEmployees.length === 0) {
    return null
  }

  return (
    <>
      {isModalOpen && (
        <TrialEmployeeDeleteModal onClose={() => setIsModalOpen(false)} onSuccess={onSuccess} />
      )}
      <Box paddingBottom="s24">
        <NoticeBox
          justifyContent="flexStart"
          message={i18n.t('trial_employees.notice_box.message')}
          tooltipLabel={i18n.t('trial_employees.notice_box.tooltip')}
          component={
            <Box flexGrow flexDirection="rowReverse">
              <Button type="secondary" onClick={handleClick}>
                {i18n.t('trial_employees.notice_box.delete_all_button')}
              </Button>
            </Box>
          }
          borderRadius={{ all: 'abs008' }}
          alignItems="center"
          fullWidth
        />
      </Box>
    </>
  )
}

export default TrialNoticeBox
